import Cookies from 'js-cookie';
var TokenKey = 'emis_edu_token';
var UserIdKey = 'emis_edu_userid';
var SchoolIdKey = 'emis_edu_schoolid';
var PhoneKey = 'emis_edu_phone';
export function getToken() {
  return Cookies.get(TokenKey);
}
export function getPhone() {
  return Cookies.get(PhoneKey);
}
export function getUserId() {
  return Cookies.get(UserIdKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function setPhone(phone) {
  return Cookies.set(PhoneKey, phone);
}
export function setUserId(userId) {
  return Cookies.set(UserIdKey, userId);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function removePhone() {
  return Cookies.remove(PhoneKey);
}
export function removeUserId() {
  return Cookies.remove(UserIdKey);
}
export function getSchoolId() {
  return Cookies.get(SchoolIdKey);
}
export function setSchoolId(schoolId) {
  return Cookies.set(SchoolIdKey, schoolId);
}
export function removeSchoolId() {
  return Cookies.remove(SchoolIdKey);
}
export function setAccountType(accountType) {
  return Cookies.set("ams_account_type", accountType);
}
export function getAccountType() {
  return Cookies.get("ams_account_type");
}
export function setRole(role) {
  return Cookies.set("ams_user_role", role);
}
export function getRole() {
  return Cookies.get("ams_user_role");
}